const ROOT_PATH = 'data-sources'

export const keys = {
  customerAttributes: (accountId: string) => [
    ROOT_PATH,
    'customer-attributes',
    accountId,
  ],
  productCatalog: (accountId: string) => [
    ROOT_PATH,
    'product-catalog',
    accountId,
  ],
} as const
